import React from 'react'

import logo from '../../assets/img/vinhos.png'

const VinhosImage = () => (
  <div className='default-image'>
    <img src={logo}  alt='Vinhos' style={{ width: '100%' }} />
  </div>
)

export default VinhosImage